export default __webpack_public_path__ + "3b4c7b95b1e7174ee0be7d25215cd059.svg";